export default {
  meta: {
    title: '选址地图详情分享'
  }
};
